export default __webpack_public_path__ + "static/media/photo.727c68c0.svg";